<template>
        <div class="container">
            <Header></Header>
            <Navigation></Navigation>
            <Breadcrumbs v-if="breadcrumbs" v-bind:breadcrumbs="breadcrumbs"></Breadcrumbs>
            <NotFoundContent></NotFoundContent>
            <Footer></Footer>
        </div>
</template>

<script>
import Header from '@/components/Header/Header.vue'
import NotFoundContent from '@/components/NotFound/NotFoundContent.vue'
import Navigation from '@/components/Common/Navigation.vue'
import Footer from '@/components/Footer/Footer.vue'
import Breadcrumbs from '@/components/Common/Breadcrumbs.vue'

export default {
  name: 'NotFound',
      components: {
        Header,
        Navigation,
        NotFoundContent,
        Breadcrumbs,
        Footer
  },
  data () {
    return {
      msg: 'Welcome to Your Vue.js App',
        head_title: 'Nie ma takiej strony',
        component_title: 'Błąd',
        breadcrumbs: {
                'parent_title': '',
                'parent_uri': '',
                'self_title': 'Nie znaleziono',
                'self_uri': window.location.href
        },
    }
  },
  head: {
        title: function() {
            return {
                inner: this.head_title
            }
        }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/NotFound/NotFound.vue